export const DEFAULT_MAP_ID = '7fedecd13382e164';
